import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiners = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3885_27580)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_3885_27580)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M-5.42768 1H39.5878C41.0085 1 42.1602 2.15169 42.1602 3.57232V30.5816C42.1602 32.0023 41.0085 33.1539 39.5878 33.1539H-5.42768C-6.84831 33.1539 -8 32.0023 -8 30.5816V3.57232C-8 2.15169 -6.84831 1 -5.42768 1Z",
					fill: "#0079BE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.5802 17.1702C30.5802 10.777 25.2439 6.35812 19.397 6.36005H14.3655C8.44895 6.35792 3.5791 10.7783 3.5791 17.1702C3.5791 23.0177 8.44895 27.8222 14.3655 27.7939H19.397C25.2435 27.8219 30.5802 23.0162 30.5802 17.1702Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.3977 7.26553C8.99131 7.26727 4.61066 11.6583 4.60938 17.0776C4.61066 22.4961 8.99157 26.8865 14.3977 26.8884C19.8053 26.8867 24.1873 22.496 24.1879 17.0776C24.1872 11.6583 19.8054 7.26746 14.3977 7.26553Z",
					fill: "#0079BE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.20996 17.0512C8.21511 14.403 9.86563 12.1447 12.1932 11.2475V22.8537C9.86563 21.9568 8.21504 19.6998 8.20996 17.0512ZM16.6343 22.8566V11.2471C18.9627 12.1422 20.6159 14.4018 20.62 17.0513C20.6159 19.7016 18.9627 21.9594 16.6343 22.8563V22.8566Z",
					fill: "white"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3885_27580",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white",
			transform: "translate(0.867188 0.897217)"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_3885_27580",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 50.1602,
			height: 32.1539,
			fill: "white",
			transform: "translate(-8 1)"
		})
	})] })]
});
export default SvgDiners;
